const CommentHelpers = {
    swr: {
        comments: (diagramId: string) => `/api/${diagramId}/comments`,
    },
};

export { CommentHelpers };
